import { SiteType } from 'types/gql-global-types'

export const SITE_TYPE = {
  MOBILE: SiteType.MOBILE,
  FIXED: SiteType.FIXED,
}
